import VendorQualification from './VendorQualification.router';

export default VendorQualification;

export { default as vendorQualificationRoutes } from './routes';
